import { Pipe, PipeTransform } from '@angular/core';
import { ToolbarFilterOption } from '../../filters-toolbar/filters-toolbar.model';
import { StackingPlanService } from '../../stacking-plan.service';
import { ColorItemSchemeClass } from '../../theme.const';
import { amountAs, makeAmountWith } from '@miq/utils';
import { Units } from 'uom-units';

/**
 * When filters changed this pipe helps to recalculate unaccounted space of stack plan service
 * @param toolBarsOptions:ToolbarFilterOption
 * Receives the array of available filters according to the selection view
 */
@Pipe({
  name: 'updateUnaccountedFilter',
  standalone: false,
})
export class UpdateUnaccountedFilterPipe implements PipeTransform {
  constructor(private stackingPlanService: StackingPlanService) {}
  transform(toolBarsOptions: ToolbarFilterOption[]): ToolbarFilterOption[] {
    const unaccountedFilter = toolBarsOptions.find(
      toolFilter => toolFilter.class === ColorItemSchemeClass.ExpireUnaccounted
    );
    if (unaccountedFilter) {
      unaccountedFilter.spaceArea = this.stackingPlanService.unaccountedSpaceTotal;
      unaccountedFilter.spaceAreaUOM = this.getCommonFloorSizeUOM(toolBarsOptions);

      const spaceAreaInSF = unaccountedFilter.spaceArea
        ? amountAs(
            Units.SquareFeet,
            makeAmountWith({
              value: unaccountedFilter.spaceArea,
              uom: unaccountedFilter.spaceAreaUOM,
            })
          )
        : 0;
      const totalSpaceArea = this.stackingPlanService.toolbarData.netRentableArea
        ? amountAs(
            Units.SquareFeet,
            makeAmountWith({
              value: this.stackingPlanService.toolbarData.netRentableArea,
              uom: this.stackingPlanService.toolbarData.netRentableAreaUOM,
            })
          )
        : 0;

      unaccountedFilter.spacePercent = totalSpaceArea ? spaceAreaInSF / totalSpaceArea : 0;
    }
    return toolBarsOptions;
  }

  private getCommonFloorSizeUOM(toolBarsOptions: ToolbarFilterOption[]): string {
    const toolBarOption = toolBarsOptions.find(tool => !!tool.spaceAreaUOM);
    return !!toolBarOption ? toolBarOption.spaceAreaUOM : 'SF'; // Default to SF if no UOM is found
  }
}
